import Immutable from 'seamless-immutable';
// ---- external imports ----

import { MAX_PLAYER_HEALTH } from '~/lib/constants';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	health: MAX_PLAYER_HEALTH,
	/**
	 * Used to prevent UI from running sound and animation again 
	 * after navigating from homepage and any page.
	 */
	didUiHandleLatestChange: true,
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
		case types.PLAYER_HEALTH_LOADED:
			return state.merge({
				health: action.playerHealth,
				didUiHandleLatestChange: true,
			});
		case types.PLAYER_HEALTH_UPDATED:
			return state.merge({
				health: action.playerHealth,
				didUiHandleLatestChange: false,
			});
		case types.PLAYER_HEALTH_UI_HANDLED_LATEST_CHANGE:
			return state.merge({
				didUiHandleLatestChange: true,
			});
		default:
			return state;
	}
}
